import { render, staticRenderFns } from "./Gateways.vue?vue&type=template&id=51ef9c7a"
import script from "./Gateways.vue?vue&type=script&lang=js"
export * from "./Gateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ef9c7a')) {
      api.createRecord('51ef9c7a', component.options)
    } else {
      api.reload('51ef9c7a', component.options)
    }
    module.hot.accept("./Gateways.vue?vue&type=template&id=51ef9c7a", function () {
      api.rerender('51ef9c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/style-two/Gateways.vue"
export default component.exports